<div *spinner="isLoading"></div>